export const Capitalize = (text) => {
  return text && typeof text === 'string'
    ? text.toLowerCase().charAt(0).toUpperCase() + text.toLowerCase().slice(1)
    : text
}

export const dateToAge = (date) => {
  if (!date) return 0
  const birthday = new Date(date.replace(/(\d+)\/(\d+)\/(\d+)/,'$3-$2-$1'))
  var ageDifMs = Date.now() - birthday.getTime()
  var ageDate = new Date(ageDifMs)
  return Math.abs(ageDate.getUTCFullYear() - 1970)
}

export const formatNb = (data) => {
  if (!data && data !== 0) return
  const [, sign, number] = data.toString().match(/^([-+]?)([\d\.]+)/) // eslint-disable-line no-useless-escape
  const value = data.length !== sign.length + number.length
    ? data.toString().slice(sign.length + number.length)
    : ''
  return sign+new Intl.NumberFormat('fr-FR').format(Math.round(number*10)/10)+value
}